import orderInterruptedCreator from '@web/middlewares/orderInterrupted'

import {RootState} from '../../interfaces'

const orderInterruptedMiddleware = orderInterruptedCreator<RootState>()

/** orderInterrupted Action 관련 미들웨어  */
export default orderInterruptedMiddleware
